"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../../../utils");

var _Detail = _interopRequireDefault(require("../../Card/Detail"));

var _Image = _interopRequireDefault(require("../../Card/Image"));

var _Base = _interopRequireDefault(require("../Base"));

require("./style.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    momentBody: {
      background: theme.palette.background.default
    },
    simple: {
      maxWidth: "100%",
      objectFit: "cover",
      width: "100%",
      maxHeight: "70vh",
      boxShadow: theme.shadows[8]
    },
    simpleGrid: {
      padding: theme.spacing(8)
    },
    simpleGridContainer: {
      overflowY: "scroll",
      maxHeight: "100vh",
      paddingBottom: "30vh"
    }
  };
});
/**
 * General Image layout Moment.
 */

function ImageMoment(props) {
  var caption = props.caption,
      direction = props.direction,
      label = props.label,
      url = props.url;
  var classes = useStyles();
  var layout = "image";
  var containerClasses = (0, _utils.classList)("moment-image-container", "moment-image-container-".concat(direction));
  return _react.default.createElement(_Base.default, _extends({
    bodyClassName: classes.momentBody
  }, props, {
    layout: layout
  }), !caption ? _react.default.createElement(_core.Grid, {
    container: true,
    justify: "center",
    className: classes.simpleGridContainer
  }, _react.default.createElement(_core.Grid, {
    item: true,
    xs: 10,
    md: 8,
    className: classes.simpleGrid
  }, _react.default.createElement("img", {
    className: classes.simple,
    src: url,
    alt: label
  }))) : _react.default.createElement("div", {
    className: containerClasses
  }, _react.default.createElement("div", {
    className: "moment-image-container__image"
  }, _react.default.createElement(_Image.default, {
    src: url
  })), _react.default.createElement("div", {
    className: "moment-image-container__caption"
  }, _react.default.createElement(_Detail.default, null, caption))));
}

;
ImageMoment.propTypes = {
  /** Information to accompany the `Image`. */
  caption: _propTypes.default.any,

  /** Determines the background and text color of the `Moment` header. */
  color: _propTypes.default.shape({
    background: _propTypes.default.string,
    text: _propTypes.default.string
  }),
  direction: _propTypes.default.oneOf(['row', 'column']),

  /** Determines the `SideBarSection` `Icon` of the `Moment`. */
  icon: _propTypes.default.element,

  /** Used to serialize the order of the `Moment`s in a `Story` */
  index: _propTypes.default.number,

  /** Determines the `SideBarSection` text of the `Moment`. */
  label: _propTypes.default.string,

  /** Paragraph text underneath the title in `Moment` header */
  subtitle: _propTypes.default.string,

  /** Main heading element of the `Moment` */
  title: _propTypes.default.node,

  /** The type of `Moment` */
  type: _propTypes.default.string,

  /** The source of the Image to render in the `Moment`'s body. */
  url: _propTypes.default.string.isRequired
};
ImageMoment.defaultProps = {
  direction: "row",
  type: "image"
};
var _default = ImageMoment;
exports.default = _default;